import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ResellerReferralsResponse } from "../../resellers.types";
import { requestGetResellerReferrals } from "./getResellerReferrals.request";
import { GetResellerReferralsRequestParams } from "./getResellerReferrals.types";

const useGetResellerReferrals = (
  resellerId: string,
  requestParams: GetResellerReferralsRequestParams,
  options?: QueryOptions<ResellerReferralsResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["reseller", resellerId, "referrals", requestParams],
    queryFn: async () =>
      await requestGetResellerReferrals(resellerId, requestParams),
    enabled: !!resellerId,
    keepPreviousData: true,
    ...options
  });

  return {
    referrals: data?.data,
    meta: data?.meta,
    summary: data?.summary,
    ...rest
  };
};

export default useGetResellerReferrals;
